import React from 'react'
import { useState } from 'react'
import {Modal, Button} from 'react-bootstrap'
import PropTypes from 'prop-types'
import {itemType, s3fileType} from '../types'
import GroupFilePublishListTable from './GroupFilePublishListTable'
import { get } from 'lodash'

export default function S3FileuploadModal(props) {
  const [showGroupPublish, setShowGroupPublish] = useState(true)
  const [disableDownload, setDisableDownload] = useState(true)
  const backDownloadLinks = () =>{
    setShowGroupPublish(true)
  }
  const handleDownloadLinks = () =>{
    setShowGroupPublish(false)
  }
  const s3Files = (get(props.item, 'fileConnection.files', [])).filter(file => file.pathOnDisk === '__s3__')

  return (
    <div>
      <Modal {...props} size='lg' backdrop="static" scrollable={true}>
        <Modal.Header closeButton>
          <Modal.Title>{showGroupPublish?'Please select the files you wish to publish':
            'The publish status for the files you selected'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <GroupFilePublishListTable
            s3FileLists={s3Files}
            show={showGroupPublish}
            setDisableDownload ={setDisableDownload}
            itemId={props.itemId}
            // setValidDownloadUrls = {setValidDownloadUrls}
          />

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={()=>{
            props.onHide(false)
            setShowGroupPublish(true)
          }}>
            Close
          </Button>
          {showGroupPublish?<Button variant="secondary" disabled={disableDownload} onClick={handleDownloadLinks}>
            Publish Selected Files
          </Button>:<><Button data='othervalue' variant="primary"  onClick={backDownloadLinks}>
            Back
          </Button>
          </>}
        </Modal.Footer>
      </Modal>
    </div>
  )
}

S3FileuploadModal.propTypes = {
  item: itemType,
  onHide: PropTypes.func,
  itemId: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  s3filelist: PropTypes.arrayOf(s3fileType),
  filepath: PropTypes.string
}
